import { Component, OnInit, AfterContentChecked, PLATFORM_ID, Inject } from '@angular/core';
import { DomSanitizer, Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { isPlatformServer } from '@angular/common';
import { FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { LocationService } from '../services/location.service';
import { HrefLang, HrefLangDefinition } from '../shared/hreflang.service';
import { AppSettings } from '../settings/app.settings';
import { SEOService } from '../shared/seo-service';


@Component({
  selector: 'company-policy',
  templateUrl: './company-policy.component.html',
  styleUrls: ['./company-policy.component.scss']
})
export class CompanyPolicyComponent implements OnInit, AfterContentChecked {
  public contactUrl: string;
  public termsUrl: string;
  public cookiesUrl: string;
  public isNode: boolean;
  constructor(private route: Router, private router: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: Object,
  private translate: TranslateService, private meta: Meta, private title: Title, private hlang: HrefLang, private seoService: SEOService) {
    this.isNode = isPlatformServer(this.platformId);
  };
  ngOnInit() {
      this.transformUrl('CONTACT_URL').subscribe(path => {
        this.contactUrl = `/${this.translate.getDefaultLang()}/${path}`;
      });

      this.transformUrl('TERMS_OF_USE_URL').subscribe(path => {
        this.termsUrl = `/${this.translate.getDefaultLang()}/${path}`;
      });

      this.transformUrl('COOKIES_POLICY_URL').subscribe(path => {
        this.cookiesUrl = `/${this.translate.getDefaultLang()}/${path}`;
      });

      this.translate.get('META_TITLE_TERM').subscribe(text => {
          this.title.setTitle(text);
      });
      this.translate.get('META_DESC_TERM').subscribe(text => {
          let tag: MetaDefinition = {
              name: 'description',
              content: text
          };
          this.meta.addTags([tag]);
      });
      const langs = [
        {lang: 'es', text: 'terminos-y-condiciones'},
        {lang: 'en', text: 'terms-of-use'}/*,
        {lang:'fr',text:'conditions-utilisation'},
        {lang:'it',text:'termini-di-utilizzo'},
        {lang:'de',text:'nutzungsbedingungen'}*/
      ];
      langs.forEach(lang => {
        const hreflang_: HrefLangDefinition = {
            rel: 'alternate',
            href: `${AppSettings.BASE_DOMAIN}/${lang.lang}/${lang.text}`,
            hreflang: `${lang.lang}`
        };
        this.hlang.addTags([hreflang_]);
      });

      this.seoService.createLinkForCanonicalURL('');
  }

  ngAfterContentChecked() {
    this.router.queryParams.subscribe(params => {
      if(!this.isNode) {
        this.scrollIntoView(params['a']);
      }
    });
  }

  transformUrl(urlToTranslate) {
   return this.translate.get(urlToTranslate);
  }

  scrollIntoView(eleID) {
  const e = document.getElementById(eleID);
    if (!!e && e.scrollIntoView) {
        e.scrollIntoView(true);
        // now account for fixed header
        const scrolledY = window.scrollY;
        if(scrolledY) {
          window.scroll(0, scrolledY - AppSettings.TOP_PADDING);
        }
    }
  }


}